import type { MarketplaceSource } from "@/types";

// #232 (UC-4): kompakte, lesbare Darstellung einer Marketplace-Quelle für Tabellen/Detail.
export function marketplaceSourceLabel(s: MarketplaceSource): string {
  switch (s.type) {
    case "github":
      return s.ref ? `github:${s.repo}@${s.ref}` : `github:${s.repo}`;
    case "url":
      return s.url;
    case "git":
      return s.ref ? `git:${s.url}@${s.ref}` : `git:${s.url}`;
    case "local":
      return `local:${s.path}`;
  }
}
